var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysMessage = function SvgSysMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 7a.996.996 0 0 1 .617-.923 1.001 1.001 0 0 1 1.306 1.305A1 1 0 0 1 10 7ZM7.002 7a.995.995 0 0 1 .617-.923 1.001 1.001 0 0 1 1.306 1.305A1 1 0 0 1 7.002 7ZM4.004 7a.995.995 0 0 1 .617-.923 1.001 1.001 0 0 1 1.306 1.305A1 1 0 0 1 4.004 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.002 12.89c1.02-.233 1.52-.82 1.767-1.33l.272-.563h8.96a1 1 0 0 0 1-.999V4.005a1 1 0 0 0-1-.998h-10a1 1 0 0 0-.999.998v8.884Zm-1 1.103V4.005c0-1.108.897-1.997 2-1.997h10c1.102 0 1.998.89 1.998 1.997v5.993a2 2 0 0 1-1.999 1.998H4.67c-.513 1.06-1.654 1.997-3.666 1.997Z"
  })));
};
export default SvgSysMessage;